import React, { useState } from 'react';
import {
  Avatar,
  TextField, InputAdornment,
  Box,
  Card,
  CardContent,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  Paper,
  Typography,
  Button
} from '@mui/material';
import { ThumbUp, Chat, Share } from '@mui/icons-material';
import Navbar from '../../global/Navbar';
import { shades } from '../../../../theme.js';
import Profile from '../../../components/medichat/profile.jsx';
import SideBar from '../../../components/medichat/sidebar.jsx';
import SearchIcon from '@mui/icons-material/Search';

// Dummy Data for Pages
const dummyPages = [
  { id: 1, name: 'Healthy Living', description: 'Tips and tricks for a healthy lifestyle.' },
  { id: 2, name: 'Mindfulness', description: 'Learn and practice mindfulness techniques.' },
  { id: 3, name: 'Workout Routines', description: 'Share and discover new workout routines.' }
];

// Main Pages Section
const Pages = () => (
  <Box sx={{
    flexGrow: 1,
    p: 1.5,
    backgroundColor: '#f8f9fa',
    overflowY: 'auto',
    marginTop: '10vh',
    maxHeight: 'calc(100vh - 10vh)'
  }}
  >
    <Typography variant='h6' sx={{ mb: 2, color: shades.neutral[900], fontWeight: 'bold' }}>
      Pages
    </Typography>

    {/* Render Pages Dynamically */}
    {dummyPages.map((page) => (
      <Card
        key={page.id} sx={{
          mb: 2,
          backgroundColor: '#fff',
          boxShadow: 'none',
          border: '1px solid #ddd'
        }}
      >
        <CardContent>
          <Box display='flex' alignItems='center'>
            <Avatar sx={{ mr: 2, backgroundColor: shades.neutral[300], color: shades.white[100] }} />
            <Box>
              <Typography variant='subtitle1' sx={{ color: shades.secondary[500] }}>{page.name}</Typography>
              <Typography variant='body2' sx={{ color: shades.neutral[600] }}>
                {page.description}
              </Typography>
            </Box>
          </Box>
          {/* Action Buttons */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              variant='outlined' size='small'
              sx={{
                mr: 1,
                borderColor: 'black',
                color: 'black',
                '&:hover': { backgroundColor: 'black', color: 'white', borderColor: 'black' }
              }}
            >
              Join
            </Button>
          </Box>
        </CardContent>
      </Card>
    ))}
  </Box>
);

// Main Layout
const HomePages = () => {
  return (
    <Box sx={{ display: 'flex', height: '100vh', backgroundColor: shades.neutral[900] }}>
      <Navbar />
      <SideBar />
      <Pages />
      <Profile />
    </Box>
  );
};

export default HomePages;
